import React from 'react';

import { mdiClockOutline } from '@lumapps/lumx/icons';
import { Combobox, Icon, Size } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';

import { QUICK_SEARCH } from '../../keys';
import { SearchBoxOptionTypeProps } from '../../types';
import { SearchBoxOptionLabel } from '../SearchBoxOptionLabel';

/**
 * Component to display a "history" type option
 * These option have a specific icon and redirects to the search page.
 */
export const SearchHistoryOption = ({
    suggestion,
    onSelect,
    historyOptions,
    actionProps,
    ...forwardedProps
}: SearchBoxOptionTypeProps) => {
    const { translateKey } = useTranslate();

    const SuggestionIcon = (
        <Icon
            alt={translateKey(QUICK_SEARCH.HISTORY_ITEM)}
            icon={historyOptions?.icon ?? mdiClockOutline}
            hasShape={historyOptions?.hasShape ?? false}
            size={Size.s}
            color={historyOptions?.color}
        />
    );

    return (
        <Combobox.Option
            value={suggestion.label}
            before={SuggestionIcon}
            onClick={onSelect}
            actionProps={actionProps}
            {...forwardedProps}
        >
            <SearchBoxOptionLabel label={suggestion.label} />
        </Combobox.Option>
    );
};
